import { useMemo, useRef } from 'react';

const useCacheAdoption = <
  T extends {
    id: string;
    updatedAt: string;
  },
>(
  data: T[],
): T[] => {
  const cachedData = useRef<{ [key: string]: T }>();
  if (cachedData.current === undefined) {
    // If there is no cached data, then create a cache object
    cachedData.current = data.reduce((acc: { [key: string]: T }, item) => {
      // Add each item to the cache
      acc[item.id] = item;

      return acc;
    }, {});
  }

  const cachedDataRef = cachedData.current;

  return useMemo(() => {
    return cachedDataRef
      ? data.map((item) => {
          if (cachedDataRef[item.id] && cachedDataRef[item.id].updatedAt === item.updatedAt) {
            // Return the cached item if the updatedAt value has not changed
            return cachedDataRef[item.id];
          } else {
            // Otherwise, update the cache and return the item
            cachedDataRef[item.id] = item;

            return item;
          }
        })
      : [];
  }, [cachedDataRef, data]);
};

export default useCacheAdoption;
